import { Link } from 'react-router-dom';
import { useState } from 'react';

const galleryItems = [
  {
    image: 'https://public.readdy.ai/ai/img_res/9d46d1d05106f523c846e90e42c52cf7.jpg',
    location: 'Seattle, WA',
    revenue: '+285%'
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Beautifully%20staged%20Airbnb%20bedroom%20with%20professional%20interior%20design%2C%20cozy%20modern%20decor%20with%20warm%20lighting%2C%20luxury%20vacation%20rental%20aesthetic%2C%20simple%20clean%20background%2C%20hospitality%20photography%20style&width=600&height=400&seq=gallery-002&orientation=landscape',
    location: 'Portland, OR',
    revenue: '+192%'
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Transformed%20garage%20into%20stylish%20Airbnb%20guest%20suite%2C%20modern%20conversion%20with%20kitchenette%20and%20living%20area%2C%20successful%20property%20renovation%2C%20simple%20clean%20background%2C%20professional%20real%20estate%20photography&width=600&height=700&seq=gallery-003&orientation=portrait',
    location: 'Austin, TX',
    revenue: '+340%'
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Modern%20Airbnb%20kitchen%20with%20professional%20staging%2C%20bright%20clean%20space%20with%20contemporary%20appliances%20and%20decor%2C%20vacation%20rental%20interior%20design%2C%20simple%20clean%20background%2C%20hospitality%20photography&width=600&height=400&seq=gallery-004&orientation=landscape',
    location: 'Denver, CO',
    revenue: '+215%'
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Happy%20homeowner%20couple%20standing%20in%20their%20successful%20Airbnb%20property%2C%20smiling%20hosts%20in%20modern%20renovated%20space%2C%20professional%20lifestyle%20photography%2C%20simple%20clean%20background%2C%20hospitality%20business%20success&width=600&height=800&seq=gallery-005&orientation=portrait',
    location: 'Nashville, TN',
    revenue: '+268%'
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Luxurious%20Airbnb%20bathroom%20with%20spa-like%20amenities%2C%20modern%20fixtures%20and%20elegant%20design%2C%20hotel%20quality%20vacation%20rental%2C%20simple%20clean%20background%2C%20professional%20interior%20photography&width=600&height=400&seq=gallery-006&orientation=landscape',
    location: 'Phoenix, AZ',
    revenue: '+178%'
  }
];

export default function GalleryPreview() {
  const [hoveredIndex, setHoveredIndex] = useState<number | null>(null);

  return (
    <section className="py-24 bg-[#2A2A2A]">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-5xl font-bold text-white mb-6" style={{ fontFamily: 'Playfair Display, serif' }}>
            Transformations We've Enabled
          </h2>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 mb-12">
          {galleryItems.map((item, index) => (
            <div 
              key={index}
              className="relative rounded-2xl overflow-hidden shadow-lg group cursor-pointer"
              style={{ height: index % 3 === 0 ? '400px' : '300px' }}
              onMouseEnter={() => setHoveredIndex(index)}
              onMouseLeave={() => setHoveredIndex(null)}
            >
              <img 
                src={item.image}
                alt={item.location}
                className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-110"
              />
              
              <div className={`absolute inset-0 bg-gradient-to-t from-black/80 via-black/40 to-transparent transition-opacity duration-300 ${
                hoveredIndex === index ? 'opacity-100' : 'opacity-0'
              }`}>
                <div className="absolute bottom-0 left-0 right-0 p-6 text-white">
                  <div className="flex items-center justify-between">
                    <div>
                      <p className="text-sm font-medium mb-1">
                        <i className="ri-map-pin-line mr-1"></i>
                        {item.location}
                      </p>
                      <p className="text-2xl font-bold text-[#FF6B6B]">
                        {item.revenue} Revenue Increase
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="text-center">
          <Link 
            to="/gallery"
            className="inline-block bg-[#FF6B6B] text-white px-8 py-4 rounded-lg font-semibold hover:bg-[#ff5252] transition-all hover:shadow-lg cursor-pointer whitespace-nowrap"
          >
            View Full Gallery
          </Link>
        </div>
      </div>
    </section>
  );
}
